export default __webpack_public_path__ + "static/media/cuciNoVoucher.33b34be5.png";